import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circleco/compass/components/Typography";
import type { ReactNode } from "react";

import { t } from "@/i18n-js/instance";

interface CompassLikeImageInputLoaderProps {
  label?: ReactNode;
}

export const CompassLikeImageInputLoader = ({
  label = `${t("uploading")}...`,
}: CompassLikeImageInputLoaderProps) => (
  <div className="bg-secondary border-primary flex size-full min-h-30 flex-col items-center justify-center rounded-lg border-2 border-dashed gap-2 p-6">
    <Loader className="!p-0" />
    <Typography variant="body-sm" color="secondary">
      {label}
    </Typography>
  </div>
);
